import { Swiper, Pagination, Autoplay } from "swiper"
Swiper.use(Pagination)
Swiper.use(Autoplay)

function verhalenSwiper() {
    new Swiper(".verhalen-swiper", {
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".verhalen-swiper-pagination",
        },
    })
}

function kennisSwiper() {
    new Swiper(".kennis-swiper", {
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".kennis-swiper-pagination",
        },
    })
}

if (document.querySelector(".verhalen-swiper")) {
    verhalenSwiper()
}
if (document.querySelector(".kennis-swiper")) {
    kennisSwiper()
}
